
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Grid } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';
import LogoPrimary from '@src/assets/icons/mokosi-primary.svg';
import LanguageSwitcher from '@components/layout/LanguageSwitcher/LanguageSwitcher';
import FooterLink from '@components/layout/Footer/FooterLink';
import './Footer.scss';

import type { Locale } from '@src/utils/locale';

type FooterProps = {
  homePageSlug: string;
  infoPages: {
    items: {
      layout: string;
      slug: string;
      title: string;
    }[];
  };
  languages: {
    locale: Locale;
    slug: string;
    text: string;
  }[];
  locale: Locale;
  onLoginIn: () => void;
};

const Footer = ({
  homePageSlug,
  locale,
  languages,
  onLoginIn,
  infoPages,
}: FooterProps) => {
  const { t } = useTranslation();

  const pm = {
    navItems: infoPages?.items || [],
  };

  const vm = {
    copyRightText: `© ${new Date().getFullYear()} ${t('footerCopyright')}`,
    mainItems: pm.navItems.filter(
      ({ layout }) =>
        !['Registracija', 'Informacinis puslapis'].includes(layout)
    ),
    sistemicItems: pm.navItems.filter(({ layout }) =>
      ['Registracija'].includes(layout)
    ),
    infoItems: pm.navItems.filter(({ layout }) =>
      ['Informacinis puslapis'].includes(layout)
    ),
  };

  return (
    <Box sx={{ fontSize: [2, null, null, 3] }}>
      <Container as="footer" p={4} className="footer">
        <Box py={4}>
          <Link sx={{ display: 'inline-block' }} to={`/${homePageSlug}`}>
            <LogoPrimary />
          </Link>
        </Box>

        <Grid gap={4} columns={[1, null, '1fr 1fr 1fr 1fr']}>
          <Box>
            {vm.mainItems.map(({ slug, title }) => (
              <FooterLink key={slug} slug={slug} title={title} />
            ))}
          </Box>
          <Box>
            {vm.sistemicItems.map(({ slug, title }) => (
              <FooterLink key={slug} slug={slug} title={title} />
            ))}

            <Box className="footer__item">
              <Themed.a
                href="/#login"
                onClick={(e) => {
                  e.preventDefault();
                  onLoginIn();
                }}
              >
                {t('logIn')}
              </Themed.a>
            </Box>
          </Box>
          <Box>
            {vm.infoItems.map(({ slug, title }) => (
              <FooterLink key={slug} slug={slug} title={title} />
            ))}
          </Box>
          <Box>
            <LanguageSwitcher pageLocale={locale} languages={languages} />
          </Box>
        </Grid>

        <Box mt={5} sx={{ color: 'grey600' }}>
          {vm.copyRightText}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
